import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/shop/gift-orders";

export const giftOrders = {
    // ...example,
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },

    receive(data){
        return axios.put(`${url}/${data._id}/receive`, data).then(result => result.data);
    },
    exchange(data){
        return axios.put(`${url}/${data._id}/exchange`).then(result => result.data);
    },
    reject(data){
        return axios.put(`${url}/${data._id}/reject`).then(result => result.data);
    },
}
